import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useBaseData } from "./BaseDataProvider.jsx";
import useCompanyPublicId from "../../hooks/useCompanyPublicId.js";
import { useAuth } from "../Auth/AuthProvider.jsx";
import { IS_APP_SKILLGEN } from "../../constants.js";

/**
 * @param {(React.ReactNode|HTMLElement)} children
 * @param {Object} rest
 * @returns {React.ReactNode}
 * @constructor
 */
const UserDataProtectedRoute = ({ children, ...rest }) => {
  const { subject, userInfo, company } = useBaseData();
  const { domain } = useCompanyPublicId();
  const { user } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) => {
        // Для Skillgen переход к выбору предмета требует токена пользователя.
        if (subject && subject.token && userInfo && userInfo.subject.available !== false && company) {
          return React.cloneElement(children);
        } else if ((company || domain) && (!IS_APP_SKILLGEN || (user && user.token))) {
          return (
            <Redirect
              to={{
                pathname: "/subjects",
                state: { from: location },
              }}
            />
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: "/auth",
                state: { from: location },
              }}
            />
          );
        }
      }}
    />
  );
};

export default UserDataProtectedRoute;
